module.exports = __webpack_public_path__ + "img/icone-fullscreen.b30bf4a6.svg";